<div class="mt-5">
    <div class="d-flex justify-content-center" *ngIf="mode">
        <div class="card col-12 col-lg-5">
            <main class="form-signin">
                <form [formGroup]="emailForm" class="form-signin" (ngSubmit)="sendEmail()" autocomplete="off">
                    <div class="text-center mb-4">
                        <h1 class="mb-3 font-weight-normal">
                            <span *ngIf="mode.includes('resend-email-confirmation-link')">
                                Resend email confirmation link
                            </span>
                            <span *ngIf="mode.includes('forgot-username-or-password')">
                                Retrieve your username or password
                            </span>
                        </h1>
                    </div>

                    <div class="form-floating mb-3">
                        <input formControlName="email" type="text" placeholder="Email" class="form-control"
                            [class.is-invalid]="submitted && emailForm.get('email')?.errors">
                        <label for="email">Email</label>
                        <span class="text-danger" *ngIf="submitted && emailForm.get('email')?.hasError('required')">
                            Email is required
                        </span>
                        <span class="text-danger" *ngIf="submitted && emailForm.get('email')?.hasError('pattern')">
                            Invalid email address
                        </span>
                    </div>

                    <div class="form-floatin" *ngIf="errorMessages.length > 0">
                        <identity-validation-messages [errorMessages]="errorMessages"></identity-validation-messages>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="d-grid">
                                <button class="btn btn-block btn-success" type="submit">Send</button>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="d-grid">
                                <button class="btn btn-block btn-danger" type="button"
                                    (click)="cancel()">Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </main>
        </div>
    </div>
</div>